export const socialLinks = {
  introVideo: '/videos/intro_vid.mp4',
  introVideoPoster: '/videos/intro_vid_thumbnail.jpg',
  tutorialVideo: '/tutorial/tutorial_vid.mp4',
  tutorialVideoPoster: '/tutorial/tutorial_vid_thumbnail.jpg',
  discordServer: 'https://discord.gg/yTbagNC7cU',
  instagram: 'https://www.instagram.com/pineapple_music_lab/',
  youtube: 'https://www.youtube.com/@Pineappl-eMusicLab',
  tiktok: 'https://www.tiktok.com/@pineapplemusiclab',
};
